<template>
  <Chart :data="chartData" :options="chartOption"></Chart>
</template>

<script lang="ts">
import { PerformanceReportSummary } from "@/types";
import { ChartData, ChartOptions } from "chart.js";
import { clone, groupBy, sum } from "ramda";
import { computed, onMounted, PropType, ref } from "vue";
import { defineComponent } from "vue-demi";
import ChartDataLabels from "chartjs-plugin-datalabels";

export default defineComponent({
  name: "PerformanceChartWh1",
  props: {
    summary: {
      type: Array as PropType<Array<PerformanceReportSummary>>,
      required: true,
    },
  },
  setup(props) {
    const chartCanvas = ref();
    const labels = ref([
      "9201",
      "9202",
      "9203",
      "9204",
      "9205",
      "9206",
      "9207",
      "9208",
      "9209",
      "9210",
      "9211",
      "9212",
      "9213",
      "9214",
      "9215",
      "9216",
      "9218",
      "9219",
      "9220",
      "9221",
    ]);

    const seriesA = computed(() => {
      if (!props.summary) return [];
      const sortedList = clone(props.summary);

      sortedList.sort((x, y) => x.month.localeCompare(y.month));

      const value = groupBy<PerformanceReportSummary>(
        (x) => x.officeCode,
        sortedList
      );
      return labels.value.map((k) => {
        const deliverySuccess = !value[k]
          ? 0
          : (sum(value[k].map((x) => x.capacityAssign)) * 100) /
            sum(value[k].map((x) => x.capacity));
        return deliverySuccess;
      });
    });
    const seriesB = computed(() => {
      if (!props.summary) return [];
      const sortedList = clone(props.summary);

      sortedList.sort((x, y) => x.month.localeCompare(y.month));

      const value = groupBy<PerformanceReportSummary>(
        (x) => x.officeCode,
        sortedList
      );
      return labels.value.map((k) => {
        const deliverySuccess = !value[k]
          ? 0
          : sum(value[k].map((x) => x.customers)) /
            sum(value[k].map((x) => x.totalShipments));
        return deliverySuccess;
      });
    });
    // const seriesB = computed(() => {
    //   if (!props.summary) return [];
    //   const sortedList = clone(props.summary);

    //   sortedList.sort((x, y) => x.month.localeCompare(y.month));

    //   const value = groupBy<PerformanceReportSummary>(
    //     (x) => x.month,
    //     sortedList
    //   );
    //   return Object.keys(value).map((k) => {
    //     return (
    //       sum(value[k].map((x) => x.customers)) /
    //       sum(value[k].map((x) => x.totalShipments))
    //     );
    //   });
    // });
    const chartData = computed(() => {
      return {
        labels: labels.value,
        datasets: [
          {
            type: "bar",
            label: "%Truck Occupancy",
            backgroundColor: "#910c29",
            data: seriesA.value,
            yAxisID: "y",
            order: 2,

            datalabels: {
              anchor: "end",
              align: "top",
              color: "black",
              formatter: (value) => value.toFixed(2),
              font: {
                weight: "bold",
              },
            },
          },
          {
            type: "line",
            label: "Avg. Outlet / Trip",
            backgroundColor: "red",
            data: seriesB.value,
            yAxisID: "y1",
            order: 1,

            datalabels: {
              anchor: "end",
              align: "start",
              color: "white",
              backgroundColor: "red",
              formatter: Math.round,
              font: {
                weight: "bold",
              },
            },
          },
        ],
      } as ChartData;
    });

    const chartOption = computed(() => {
      return {
        responsive: true,
        scales: {
          y: {
            type: "linear",
            display: true,
            position: "left",
          },
          y1: {
            type: "linear",
            display: true,
            position: "right",
          },
        },
      } as ChartOptions;
    });

    return { chartData, chartOption };
  },
});
</script>

<style></style>
